import {
  Col,
  Divider,
  Row,
  Space,
  Spin,
  Table,
  Tag,
  Typography,
  Modal,
  Rate,
  Button,
  Badge,
} from 'antd';
import Link from 'antd/lib/typography/Link';
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { NumberParam, useQueryParams } from 'use-query-params';
import { FlexBox } from '../../../../components/atoms/FlexBox';
import { CycleToggle } from '../../../../components/atoms/ItemToggle';
import { UserAvatar } from '../../../../components/atoms/UserAvatar';
import ReviewPreview from '../../../../components/molecules/ReviewPreview/ReviewPreview';
import { useConnection, useUserInfo } from '../../../../connection/Application';
import { PerformanceCycle } from '../../../../entity/PerformanceCycle';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import {
  AlignLeftOutlined,
  ArrowRightOutlined,
  CaretDownOutlined,
  CaretRightOutlined,
  CaretUpOutlined,
  ExclamationCircleOutlined,
  RetweetOutlined,
  StarFilled,
} from '@ant-design/icons';
import { PeerReviewModel } from '../peer-reviews/PeerReviews';
import { RichText } from '../../../../components/RichText/RichText';
import ReactHtmlParser from '../../../../utils/SafeHtmlParser';
import { useHistory } from 'react-router-dom';
import { PageHeader } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
const { confirm } = Modal;
const { Title, Text } = Typography;

const regex = /(<([^>]+)>)/gi;

const PeerReviewsApprove: FC = () => {
  const [query, setQuery] = useQueryParams({
    cycle: NumberParam,
  });
  const cycleRef = useRef(query.cycle);
  const user = useUserInfo();
  const history = useHistory();
  const [cycles, setCycles] = useState<PerformanceCycle[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loading1, setLoading1] = useState<boolean>(false);
  const [fetching, setFetching] = useState<boolean>(false);
  const [filterTableData, setFilterTableData] = useState<any>([]);
  const [expandedRow, setExpandedRow] = useState<string[]>([]);
  const [record, setRecord] = useState<undefined | any>(undefined);
  const [showContent, setShowContent] = useState<boolean>(true);
  const connection = useConnection();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [submitData, setSubmitData] = useState<PeerReviewModel>({
    criteriaSet: [],
    overallComment: '',
    submitTime: '',
    cycle: query?.cycle,
    submittingUser: 0,
    peerReviewType: true,
  });
  // const events = useEvents();

  const columns = useMemo(() => {
    return [
      {
        title: 'Peer Name',
        dataIndex: 'name',
        key: 'peerName',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => {
          return {
            props: {
              style: { display: 'flex', height: '60px' },
            },
            children: (
              <Space style={{ paddingLeft: record.parent ? '0px' : '35px' }}>
                <UserAvatar type={'user'} src={record.image} />
                <Link
                  onClick={() => {
                    if (record.parent) {
                      history.push(
                        `/webux/peer-reviews-approve/${record?.id}/${record?.name}?cycle=${query.cycle}`,
                      );
                    } else {
                      if (
                        !(
                          record.status == '' ||
                          record.status == 'not submitted' ||
                          record.status === 'drafted'
                        )
                      ) {
                        setSubmitData({
                          ...submitData,
                          criteriaSet: record?.criteriaSet?.criterias,
                          overallComment: record?.overallComment ?? '',
                          peerReviewType: record?.peerReviewType ?? true,
                        });
                        window.onbeforeunload = function () {
                          return 'Data will be lost if you leave the page, are you sure?';
                        };
                        setModalVisible(true);
                        setRecord(record);
                      }
                    }
                  }}>
                  {text}
                </Link>
              </Space>
            ),
          };
        },
      },
      {
        title: 'Team',
        dataIndex: 'teamName',
        key: 'teamName',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {!record.parent && (
              <>
                <UserAvatar type={'team'} src={record.teamImage} />
                <Typography>{text}</Typography>
              </>
            )}
          </Space>
        ),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {record.parent ? (
              <>
                {record.notSubmitted !== 0 && (
                  <Tag color={'blue'}>Not submitted : {record.notSubmitted}</Tag>
                )}
                {record.submitted !== 0 && (
                  <Tag color={'yellow'}>Submitted : {record.submitted}</Tag>
                )}
                {record.rejected !== 0 && <Tag color={'red'}>Rejected : {record.rejected}</Tag>}
                {record.approved !== 0 && <Tag color={'green'}>Approved : {record.approved}</Tag>}
              </>
            ) : (
              <>
                {(record.status == '' ||
                  record.status == 'not submitted' ||
                  record.status === 'drafted') && <Tag color={'blue'}>Not submitted</Tag>}
                {record.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
                {record.status == 'rejected' && <Tag color={'red'}>Rejected</Tag>}
                {record.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
              </>
            )}
          </Space>
        ),
      },
      {
        title: 'Score',
        dataIndex: 'marks',
        key: 'marks',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {record.parent ? (
              <Badge
                count={Math.round(record.marks ?? 0) + '%'}
                showZero
                overflowCount={120}
                style={{ fontSize: '16px' }}
                color={
                  Math.round(record.marks ?? 0) > 85
                    ? '#52c41a'
                    : Math.round(record.marks ?? 0) > 60
                    ? '#faad14'
                    : ''
                }
              />
            ) : (
              // <Progress
              //   type="circle"
              //   percent={record.marks ?? 0}
              //   width={65}
              //   format={() => `${Math.round(record.marks ?? 0)}%`}
              // />
              <>
                {!(
                  record.status == '' ||
                  record.status == 'not submitted' ||
                  record.status === 'drafted'
                ) && (
                  <Badge
                    count={
                      record.criteriaSet.criterias.reduce(
                        (x: any, y: any) => x + (y.answer / y.type) * 100,
                        0,
                      ) /
                        record.criteriaSet.criterias.length +
                      '%'
                    }
                    showZero
                    overflowCount={120}
                    style={{ fontSize: '16px' }}
                    color={
                      record.criteriaSet.criterias.reduce(
                        (x: any, y: any) => x + (y.answer / y.type) * 100,
                        0,
                      ) /
                        record.criteriaSet.criterias.length >
                      85
                        ? '#52c41a'
                        : record.criteriaSet.criterias.reduce(
                            (x: any, y: any) => x + (y.answer / y.type) * 100,
                            0,
                          ) /
                            record.criteriaSet.criterias.length >
                          60
                        ? '#faad14'
                        : ''
                    }
                  />
                  // <Progress
                  //   type="circle"
                  //   percent={
                  //     record.criteriaSet.criterias.reduce(
                  //       (x: any, y: any) => x + (y.answer / y.type) * 100,
                  //       0,
                  //     ) / record.criteriaSet.criterias.length
                  //   }
                  //   width={65}
                  //   format={() =>
                  //     `${
                  //       record.criteriaSet.criterias.reduce(
                  //         (x: any, y: any) => x + (y.answer / y.type) * 100,
                  //         0,
                  //       ) / record.criteriaSet.criterias.length
                  //     }%`
                  //   }
                  // />
                )}
              </>
            )}
          </Space>
        ),
      },
    ];
  }, [history, query.cycle, submitData]);

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      setLoading(true);
      connection
        .get<{ performanceCycle: PerformanceCycle[]; closestCycle: PerformanceCycle }>('cycles')
        .then((value) => {
          setCycles(value.performanceCycle);
          if (cycleRef.current === undefined) {
            setQuery(
              {
                cycle: value.closestCycle.id,
              },
              'replace',
            );
          }
        })
        .catch(() => setLoading(false));
    }
  }, [connection, setQuery]);

  useEffect(() => {
    setLoading(true);
    if (query?.cycle) {
      connection
        .get(`goals/review/user/approve/${query?.cycle}`)
        .then((users: any) => {
          setFilterTableData(
            users.peersData.map((e: any) => ({
              ...e,
              parent: true,
              key: e.id,
              children: e.peerReviews.map((e1: any) => ({
                parent: false,
                ...e1,
                name: e1.reviewerName,
                image: e1.reviewerImage,
              })),
            })),
          );
          // setGoalSummary(goalSummary);
          // setValue(goalSummary?.criteriaSetId ?? 0);
        })
        .finally(() => setLoading(false));
    }
  }, [connection, query?.cycle, fetching]);

  const createPeerReview = useCallback(() => {
    setLoading1(true);
    if (submitData?.criteriaSet?.length !== 0) {
      connection
        .patch(`goals/review/user/approve/${record.id}`, {
          answers: submitData?.criteriaSet?.map((e) => ({
            id: e.id,
            answer: ((e.answer ?? 0) / e.type) * 100,
            comment: e.comment,
          })),
          overallComment: submitData?.overallComment,
          peerReviewType: submitData?.peerReviewType ?? true,
        })
        .then(() => {
          window.onbeforeunload = null;
          setModalVisible(false);
          setSubmitData({
            criteriaSet: [],
            overallComment: '',
            submitTime: '',
            cycle: query?.cycle,
            submittingUser: 0,
            peerReviewType: true,
          });
          setFetching(!fetching);
          setRecord(undefined);
          setLoading1(false);
        })
        .catch(() => setLoading1(false));
    } else {
      setLoading1(false);
    }
  }, [
    submitData.peerReviewType,
    connection,
    query?.cycle,
    fetching,
    record?.id,
    submitData?.criteriaSet,
    submitData?.overallComment,
  ]);

  const rejectPeerReview = useCallback(() => {
    setLoading1(true);
    if (submitData?.criteriaSet?.length !== 0) {
      connection
        .patch(`goals/review/user/reject/${record?.id}`, {
          peerReviewType: submitData?.peerReviewType ?? true,
        })
        .then(() => {
          window.onbeforeunload = null;
          setModalVisible(false);
          setSubmitData({
            criteriaSet: [],
            overallComment: '',
            submitTime: '',
            cycle: query?.cycle,
            submittingUser: 0,
            peerReviewType: true,
          });
          setFetching(!fetching);
          setRecord(undefined);
          setLoading1(false);
        })
        .catch(() => setLoading1(false));
    } else {
      setLoading1(false);
    }
  }, [
    submitData?.criteriaSet?.length,
    submitData?.peerReviewType,
    connection,
    record?.id,
    query?.cycle,
    fetching,
  ]);

  const showApproveModal = useCallback(() => {
    confirm({
      title: 'Submitting your review',
      icon: <ExclamationCircleOutlined />,
      content: `If you approve you won't be able to change`,
      okText: `Approve`,
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onOk() {
        setSubmitData({
          ...submitData,
          cycle: query?.cycle,
          submittingUser: user?.userId,
          submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
        });
        createPeerReview();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [createPeerReview, query?.cycle, submitData, user?.userId]);

  const showRejectModal = useCallback(() => {
    confirm({
      title: 'Rejecting your review',
      icon: <ExclamationCircleOutlined />,
      content: `Do you want reject this peer review`,
      okText: `Reject`,
      centered: true,
      okType: 'primary',
      okButtonProps: {
        danger: true,
      },
      cancelText: 'Cancel',
      onOk() {
        setSubmitData({
          ...submitData,
          cycle: query?.cycle,
          submittingUser: user?.userId,
          submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
        });
        rejectPeerReview();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [query?.cycle, rejectPeerReview, submitData, user?.userId]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title="Peer Review Approvals"
        subTitle="Moderate peer reviews among team members"
        // breadcrumb={{
        //   routes: [
        //     {
        //       path: 'goals',
        //       breadcrumbName: `Team Peer Reviews`,
        //     },
        //   ],
        // }}
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <FlexBox>
            <CycleToggle
              value={parseInt(`${query?.cycle}`)}
              onChange={(value) =>
                setQuery(
                  {
                    cycle: value,
                  },
                  'replace',
                )
              }
              data={cycles}
            />
          </FlexBox>
          <Spin spinning={loading}>
            {/*<FlexBox style={{ marginBottom: '2%', alignItems: 'center' }}>*/}
            {/*  <Typography style={{ marginRight: '2%' }}>Selected Peer :- </Typography>*/}
            {/*  {peerData.length > 0 && (*/}
            {/*    <Select*/}
            {/*      showSearch*/}
            {/*      style={{ width: '250px' }}*/}
            {/*      onChange={(value) => {*/}
            {/*        setFilterUser(value);*/}
            {/*        setQuery(*/}
            {/*          value == ''*/}
            {/*            ? {*/}
            {/*                cycle: query.cycle,*/}
            {/*              }*/}
            {/*            : {*/}
            {/*                user: value,*/}
            {/*                cycle: query.cycle,*/}
            {/*              },*/}
            {/*          'replace',*/}
            {/*        );*/}
            {/*      }}*/}
            {/*      value={filterUser}*/}
            {/*      filterOption={(input, option) =>*/}
            {/*        option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0*/}
            {/*      }>*/}
            {/*      <Select.Option key={0} value="">*/}
            {/*        {'All peers'}*/}
            {/*      </Select.Option>*/}
            {/*      {peerData.map((item: any, key: number) => (*/}
            {/*        <Select.Option key={key} value={item.id + ''}>*/}
            {/*          {item.value}*/}
            {/*        </Select.Option>*/}
            {/*      ))}*/}
            {/*    </Select>*/}
            {/*  )}*/}
            {/*</FlexBox>*/}
            <Table
              size="small"
              columns={columns}
              dataSource={filterTableData}
              indentSize={70}
              pagination={false}
              expandedRowKeys={expandedRow}
              expandable={{
                expandIcon: ({ expanded, onExpand, record }) =>
                  record?.children?.length > 0 &&
                  record?.children &&
                  (expanded ? (
                    <span style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>
                      <CaretDownOutlined
                        onClick={(e: any) => {
                          if (expandedRow.includes(record.key)) {
                            setExpandedRow(expandedRow.filter((n) => n !== record.key));
                          }
                          // setExpanded(false);
                          onExpand(record, e);
                        }}
                      />
                    </span>
                  ) : (
                    <span style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>
                      <CaretRightOutlined
                        onClick={(e: any) => {
                          if (!expandedRow.includes(record.key)) {
                            setExpandedRow([...expandedRow, record.key]);
                          }
                          onExpand(record, e);
                        }}
                      />
                    </span>
                  )),
              }}
            />
            {/*<Table*/}
            {/*  size="small"*/}
            {/*  columns={columns}*/}
            {/*  dataSource={filterTableData}*/}
            {/*  expandable={{ indentSize: 0 }}*/}
            {/*  pagination={false}*/}
            {/*/>*/}
          </Spin>
        </WebUxPageItem>
      </WebUxPageContent>
      <Modal
        destroyOnClose={true}
        open={modalVisible}
        onCancel={() => {
          setRecord(undefined);
          setSubmitData({
            criteriaSet: [],
            overallComment: '',
            submitTime: '',
            cycle: query?.cycle,
            submittingUser: 0,
            peerReviewType: true,
          });
          window.onbeforeunload = null;
          setModalVisible(false);
          // events.emit('PEER_REVIEW_CLOSE');
        }}
        footer={
          record?.status == 'approved'
            ? [
                <Button
                  key="submit"
                  type="default"
                  disabled={loading1}
                  onClick={() => {
                    setRecord(undefined);
                    setSubmitData({
                      criteriaSet: [],
                      overallComment: '',
                      submitTime: '',
                      cycle: query?.cycle,
                      submittingUser: 0,
                      peerReviewType: true,
                    });
                    window.onbeforeunload = null;
                    setModalVisible(false);
                    // events.emit('PEER_REVIEW_CLOSE');
                  }}>
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  disabled={
                    submitData?.overallComment === '' ||
                    submitData?.criteriaSet?.length === 0 ||
                    submitData?.criteriaSet?.findIndex(
                      (e) => e.answer === 0 || e.answer === null || e.answer === undefined,
                      // e.comment === '' ||
                      // e.comment === null ||
                      // e.comment === undefined,
                    ) !== -1
                  }
                  loading={loading1}
                  onClick={() => showApproveModal()}>
                  Re-Submit
                </Button>,
              ]
            : [
                <Button
                  key="submit"
                  type="default"
                  disabled={loading1}
                  onClick={() => {
                    setRecord(undefined);
                    setSubmitData({
                      criteriaSet: [],
                      overallComment: '',
                      submitTime: '',
                      cycle: query?.cycle,
                      submittingUser: 0,
                      peerReviewType: true,
                    });
                    window.onbeforeunload = null;
                    setModalVisible(false);
                    // events.emit('PEER_REVIEW_CLOSE');
                  }}>
                  Cancel
                </Button>,
                <Button key="submit" danger loading={loading1} onClick={() => showRejectModal()}>
                  Reject
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  disabled={
                    submitData?.overallComment === '' ||
                    submitData?.criteriaSet?.length === 0 ||
                    submitData?.criteriaSet?.findIndex(
                      (e) => e.answer === 0 || e.answer === null || e.answer === undefined,
                      // e.comment === '' ||
                      // e.comment === null ||
                      // e.comment === undefined,
                    ) !== -1
                  }
                  loading={loading1}
                  onClick={() => showApproveModal()}>
                  Approve
                </Button>,
              ]
        }>
        <Row style={{ marginTop: '3%' }}>
          <UserAvatar src={record?.peerImage ?? null} size={80} />
          <Col style={{ marginLeft: '3%' }}>
            <Title level={3} style={{ margin: 0 }}>
              {record?.peerName}
            </Title>
            <Text type="secondary">{record?.peerDesignation}</Text>
            <div>
              <Tag color="blue">{record?.teamName}</Tag>
            </div>
          </Col>
        </Row>
        <Divider style={{ marginTop: '2%' }} />
        <div style={{ marginLeft: '1%' }}>
          <ReviewPreview
            mode={record?.mode}
            criterias={record?.criteriaSet?.criterias}
            onChange={(val) =>
              setSubmitData({
                ...submitData,
                criteriaSet: val,
              })
            }
          />
        </div>
        <Space style={{ marginTop: '2%' }}>
          <StarFilled style={{ color: 'red', fontSize: 7, paddingRight: 5 }} />
          <AlignLeftOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
          <Text type="secondary">Overall Comment</Text>
        </Space>
        <Divider orientation="left" style={{ marginTop: 0, marginBottom: 0 }} />
        <div style={{ marginTop: '2%' }}>
          <RichText
            placeholder={'Add your overall comment'}
            value={submitData?.overallComment}
            maxLength={10000}
            onChange={(e) => setSubmitData({ ...submitData, overallComment: e })}
          />
        </div>
        <Row style={{ alignItems: 'center', marginTop: 20 }}>
          <Space>
            <Title level={5}>Activity</Title>
            <RetweetOutlined style={{ fontSize: 20 }} />
          </Space>
        </Row>
        <Link onClick={() => setShowContent(!showContent)}>
          <Space className="div_hover">
            <Text>Show Activities</Text>
            {!showContent ? (
              <CaretDownOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
            ) : (
              <CaretUpOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
            )}
          </Space>
        </Link>
        {record?.peerReviewHistory?.length !== 0 &&
          showContent &&
          record?.peerReviewHistory?.map((item: any, key: any) => {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.image} />
                    <Text strong>{item?.name}</Text>
                    <Text type="secondary">{item.date}</Text>
                  </Space>
                </Row>
                <Row>
                  <Text strong>
                    Status:
                    {(record.status == '' ||
                      record.status == 'not submitted' ||
                      record.status === 'drafted') && <Tag color={'blue'}>Not submitted</Tag>}
                    {item.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
                    {item.status == 'rejected' && <Tag color={'red'}>Rejected</Tag>}
                    {item.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
                  </Text>
                </Row>
                {item?.status === 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 20 }}>
                          <Text type="secondary">{`Submitted ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
                {item?.status !== 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 10 }}>
                          <Text type="secondary">{`Updated ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Rate
                                value={(e.oldAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                              <ArrowRightOutlined
                                style={{ paddingTop: 6, paddingLeft: 15, paddingRight: 15 }}
                              />
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>

                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                                {'   '}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {'   '}
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                                {'   '}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {'   '}
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            );
          })}
      </Modal>
    </WebUxPage>
  );
};

export default PeerReviewsApprove;
